import { inject, Injectable } from '@angular/core';
import { CsrfService } from './csrf.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AccountSelectionService {
  http = inject(HttpClient);

  constructor(private readonly csrfService: CsrfService) {}

  getAdminData() {
    return this.csrfService.fetchWithCsrfGet('/cw/api/admin');
  }

  getGroupData() {
    return this.csrfService.fetchWithCsrfGet('/cw/api/modeselector');
  }

  selectAccount(selectedAccount: string) {
    const url = `/cw/api/admin?selectaccount=${selectedAccount}`;
    console.log('Constructed selectAccount URL:', url);
    return this.csrfService.fetchWithCsrfGet(url);
  }
}
